'use client'

import { useTranslation } from '@/lib/i18n'

/** "Page 4", "Pages 4–6", or null when the source has no pages. */
export function usePageLabel() {
  const { t } = useTranslation()
  return (from: number | null, to: number | null): string | null => {
    if (from === null) return null
    if (to !== null && to !== from) return t('knowledgePortal.answer.pages', { from, to })
    return t('knowledgePortal.answer.page', { page: from })
  }
}
